import React, { useEffect, useState } from "react";
import "./OpenResearchStudies.css";
import Navbar from "../navbar/Navbar";
import { getPublicStudies } from "../../services/studies";
import StarConstellation from "./StarConstellation";
import ResearchStudyDetail from "./ResearchStudyDetail";

const OpenResearchStudies = () => {
    const [studies, setStudies] = useState([]);
    const [selectedStudy, setSelectedStudy] = useState(null);
    const [hoveredStudy, setHoveredStudy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStudies = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await getPublicStudies();
                setStudies(data);
                if (data.length > 0) {
                    setSelectedStudy(data[0]);
                }
            } catch (err) {
                console.error("Error fetching public studies:", err);
                setError(err.message || "Failed to load public studies");
            } finally {
                setLoading(false);
            }
        };

        fetchStudies();
    }, []);

    const handleStarClick = (study) => {
        setSelectedStudy(study);
    };

    const handleStarHover = (study) => {
        setHoveredStudy(study);
    };

    const handleStarLeave = () => {
        setHoveredStudy(null);
    };

    return (
        <div className="open-studies-page">
            {/* Dark Starfield Background */}
            <div className="starfield-background"></div>

            <Navbar />

            <main className="open-studies-main">
                <div className="page-header">
                    <h1 className="page-title">Research Constellations</h1>
                    <p className="page-subtitle">
                        Explore publicly shared research studies. Hover over stars to see connections, click to view details.
                    </p>
                    <div style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "10px",
                        marginTop: "14px",
                        padding: "8px 16px",
                        background: "rgba(255,193,7,0.1)",
                        border: "1px solid rgba(255,193,7,0.35)",
                        borderRadius: "999px",
                        color: "#ffc107",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "13px",
                        fontWeight: 500,
                    }}>
                        <i className="fa fa-wrench" />
                        <span>This Research Apps space is a work in progress — expect frequent changes.</span>
                    </div>
                </div>

                <div className="split-layout">
                    {/* Left Panel - Constellation */}
                    <section className="constellation-panel">
                        {loading && (
                            <div className="constellation-loading">
                                <i className="fa fa-spinner fa-spin"></i>
                                <span>Loading research studies...</span>
                            </div>
                        )}
                        {error && (
                            <div className="constellation-error">
                                <i className="fa fa-exclamation-triangle"></i>
                                <span>{error}</span>
                            </div>
                        )}
                        {!loading && !error && studies.length === 0 && (
                            <div className="constellation-empty">
                                <i className="fa fa-star-o"></i>
                                <span>No public studies available yet</span>
                                <p>Be the first to share your research!</p>
                            </div>
                        )}
                        {!loading && !error && studies.length > 0 && (
                            <StarConstellation
                                studies={studies}
                                selectedStudy={selectedStudy}
                                hoveredStudy={hoveredStudy}
                                onStarClick={handleStarClick}
                                onStarHover={handleStarHover}
                                onStarLeave={handleStarLeave}
                            />
                        )}
                    </section>

                    {/* Right Panel - Details */}
                    <section className="detail-panel">
                        {selectedStudy ? (
                            <ResearchStudyDetail study={selectedStudy} />
                        ) : (
                            <div className="no-selection">
                                <i className="fa fa-star"></i>
                                <p>Select a star to view study details</p>
                            </div>
                        )}
                    </section>
                </div>
            </main>
        </div>
    );
};

export default OpenResearchStudies;
